module.exports = "<app-header></app-header>\n<div class=\"page-has-nav\">\n  <ng-content></ng-content>\n</div>"